import { Injectable } from '@angular/core';
import {
  applyActionCode,
  checkActionCode,
  confirmPasswordReset,
  signOut,
  validatePassword,
  verifyPasswordResetCode,
} from 'firebase/auth';
import { auth } from '../app.component';

@Injectable({ providedIn: 'root' })
export class PasswordResetService {
  auth = auth;

  verifyCode(code: string) {
    return verifyPasswordResetCode(this.auth, code);
  }

  async verifyEmail(code: string) {
    const info = await checkActionCode(this.auth, code);
    if (info.operation !== 'VERIFY_EMAIL') {
      throw { code: 'auth/invalid-action-code' };
    }
    await applyActionCode(this.auth, code);
    return info.data.email || '';
  }

  validate(password: string) {
    return validatePassword(this.auth, password);
  }

  confirm(code: string, password: string) {
    return confirmPasswordReset(this.auth, code, password);
  }

  signOut() {
    return signOut(this.auth);
  }
}
